<template lang="pug">

	#cartComponent
		#cart.mini-cart(v-bind:class="{'loading' : storeState.updatingCart, 'show' : storeState.showCart}")
			.cart-inner
				.cart-title
					p Your Cart
					.cart-close.cursor-pointer(@click="toggleCart()") X

				template(v-if="storeState.cart && storeState.cart.lines")
					.line-items
						template(v-if="cartItems.length > 0")
							.line-item(v-for="item in cartItems")
								.item-image(v-if="getItemImage(item)" :style="{ backgroundImage: 'url(' + getItemImage(item) + ')'}").m-05
								.item-detail
									.item-row {{ getItemTitle(item) }}
									.item-row(v-if="getItemVariantTitle(item) != 'Default Title'") {{ getItemVariantTitle(item) }}
									.item-row(v-else) -
									.qty-control
										.qty-control-wrapper
											.qty-decrease.cursor-pointer(@click="updateItem(item.node.id, (item.node.quantity - 1))") -
											.qty.border-l-2.border-r-2.border-blue {{ item.node.quantity }}
											.qty-increase.cursor-pointer(@click="updateItem(item.node.id, (item.node.quantity + 1))") +
										.remove-item.cursor-pointer.pl-15(@click="removeItem(item.node.id)") Remove
									.py-015.text-black.bg-lightgrey.text-right.px-1(v-html="calcPrice((item.node.quantity * getItemPrice(item)))")

						template(v-if="cartItems.length === 0")
							.cart-empty.flex.justify-center.items-center.p-1.mt-auto
								p Your cart is empty...

						template(v-if="cartItems.length > 0")
							p.flex.justify-center.p-05.w-full.text-black.text-sm.border-b-2.border-blue.mt-auto.w-full.text-center Shipping calculated at checkout
							.line-items
								.line-item.totals.bg-lightgrey.text-black
									.label.flex.justify-center.p-025 Total:
									.total.col-span-3.flex.justify-end.border-l-2.border-blue.py-025.px-1(v-html="calcPrice(cartSubtotal)")

							p.flex.justify-center.p-05.w-full.text-black.text-sm 10% off all orders over $300
							a.checkout-btn(:href="storeState.cart.checkoutUrl") Checkout
						template(v-else)
							.checkout-btn.mt-auto.cursor-pointer(@click="toggleCart()") Continue Shopping

				template(v-else)
					.cart-empty.flex.justify-center.items-center.p-1.mt-auto
						p Loading cart...

		#cartOverlay(v-bind:class="{'show' : storeState.showCart}" @click="toggleCart()")
		
				
</template>

<script>
import { store } from "./../shopify/store.js";

export default {
	name: 'Cart',
	data() {
		return {
			storeState: store.state,
			loading: false
		}
	},
	computed: {
		cartItems() {
			return this.storeState.cart?.lines?.edges || [];
		},
		cartSubtotal() {
			return this.storeState.cart?.cost?.totalAmount?.amount || 0;
		}
	},
	watch: {
		showCart: function() {
			if (store.state.showCart) {
				document.documentElement.classList.add('overflow-hidden')
			} else {
				document.documentElement.classList.remove('overflow-hidden')
			}
		}
	},
	methods: {
		toggleCart() {
			this.storeState.showCart = !this.storeState.showCart 
		},
		updateItem(lineId, qty) {
			if (qty > 0) {
				store.updateLineItem(lineId, qty)
			} else {
				store.removeLineItem(lineId)
			}
		},
		removeItem(lineId) {
			store.removeLineItem(lineId)
		},
		calcPrice: function(input) {
			return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(input)
		},
		afterPaySplit() {
			return this.calcPrice(this.cartSubtotal / 4)
		},
		getItemImage(item) {
			return item?.node?.merchandise?.product?.images?.edges?.[0]?.node?.url
		},
		getItemTitle(item) {
			return item?.node?.merchandise?.product?.title || 'Unknown Product'
		},
		getItemVariantTitle(item) {
			return item?.node?.merchandise?.title || 'Default Title'
		},
		getItemPrice(item) {
			return item?.node?.merchandise?.price?.amount || 0
		}
	}
};
</script>
